import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
// import '../../App.css';

function CompanyIndex() {
  const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  let companyid = companyId;
  if (isSuperAdmin == true && companyId == superCompanyId) {
    companyid = 0;
  }


  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);

  useEffect(() => {
    fetchData('CompanyApi', `/${companyid}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Company Details:', error);
      });
  }, []);


  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <div className='w-full mb-2 flex'>
        <h5 className='block uppercase tracking-wide text-black  productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Company</h5>
        {/* {isSuperAdmin && companyId == superCompanyId && (
          <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/companyCreate"
              className="linkcolor"
              style={{ marginLeft: '8px' }}
            >
              CREATE NEW
            </Button>
        )} */}
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f3f3f3' }}> {/* Set background color */}
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Company Code</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Contact Number 1</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Contact Number 2</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Email</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>GST Number</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(item => (
                <TableRow key={item.Id}>
                  <TableCell>{item.Name}</TableCell>
                  <TableCell>{item.CompanyCode}</TableCell>
                  <TableCell>{item.ContactNumber1}</TableCell>
                  <TableCell>{item.ContactNumber2}</TableCell>
                  <TableCell>{item.Email}</TableCell>
                  <TableCell>{item.GSTNumber}</TableCell>
                  <TableCell>
                    <Link to={`/companyEdit/${item.ID}`}>
                      <IconButton>
                        <EditIcon />
                      </IconButton>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>

  );
}

export default CompanyIndex;

